import Vue from "vue";
import Router from "vue-router";
// import Main from "./views/layout/main.vue";
import LeaderMain from "./views/pages/leader-page/leader-main.vue";
import Home from "./views/layoutnew/main.vue";
import store from "./store/store.js";

Vue.use(Router);

const staticRoutes = [
    {
        path: "/leader-main",
        component: LeaderMain,
        name: "main",
        children: [
            //===================总览首页--start======================
            {
                // 香肠首页 tab版
                path: "/main-home",
                name: "main-home",
                component: () => import("./views/pages/index/main-home.vue"),
                meta: {
                    title: "首页",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true,
                    isIndex: false
                }
            },
            {
                path: "/main-home-en",
                name: "main-home-en",
                component: () => import("./views/pages/index/main-home-en.vue"),
                meta: {
                    title: "首页",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: true,
                    noMenu: true,
                    isIndex: false
                }
            },
            {
                // 香肠首页 tab版
                path: "/main-index",
                name: "index",
                component: () => import("./views/pages/index/main-index.vue"),
                meta: {
                    title: "首页",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true,
                    isIndex: true
                }
            },
            {
                // 香肠首页
                path: "/index-home",
                name: "index",
                component: () => import("./views/pages/index/index-home.vue"),
                meta: {
                    title: "首页",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true,
                    noHeader: true,
                    noBottom: false
                }
            },
            {
                // 香肠首页 tab版
                path: "/index-home-tab",
                name: "index",
                component: () =>
                    import("./views/pages/index/index-home-tab.vue"),
                meta: {
                    title: "首页",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true,
                    noHeader: true,
                    noBottom: false
                }
            },
            {
                // 聚元工贸首页
                path: "/jygm-home",
                name: "index",
                component: () => import("./views/pages/index/index.vue"),
                meta: {
                    title: "聚元工贸",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true,
                    noHeader: true,
                    noBottom: false
                }
            },
            {
                path: "/index-yn",
                name: "index-yn",
                component: () => import("./views/pages/index-yn/index-yn.vue"),
                meta: {
                    title: "前列电缆电气接线图",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true
                }
            },
            {
                path: "/water_diagram",
                name: "water_diagram",
                component: () =>
                    import("./views/pages/index-yn/water_diagram.vue"),
                meta: {
                    title: "水表接线图",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            {
                path: "/diagram_roof",
                name: "diagram_roof",
                component: () =>
                    import("./views/pages/index-yn/diagram_roof.vue"),
                meta: {
                    title: "屋顶接线图",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            {
                path: "/diagram_one",
                name: "diagram_one",
                component: () =>
                    import("./views/pages/index-yn/diagram_one.vue"),
                meta: {
                    title: "1#变电房",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            {
                path: "/diagram_two",
                name: "diagram_two",
                component: () =>
                    import("./views/pages/index-yn/diagram_two.vue"),
                meta: {
                    title: "2#变电房",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            {
                path: "/diagram_third",
                name: "diagram_third",
                component: () =>
                    import("./views/pages/index-yn/diagram_third.vue"),
                meta: {
                    title: "3#箱变",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            {
                path: "/index-jygm",
                name: "index-jygm",
                component: () =>
                    import("./views/pages/index-jygm/index-jygm.vue"),
                meta: {
                    title: "聚元工贸电气接线图",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            {
                path: "/index-jthnt",
                name: "index-jthnt",
                component: () =>
                    import("./views/pages/index-jthnt/index-jthnt.vue"),
                meta: {
                    title: "建通混凝土电气接线图",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: false
                }
            },
            //==============总览首页-----------------end
            {
                path: "/air_condition",
                name: "air_condition",
                component: () =>
                    import("./views/pages/airCondition-system/index.vue"),
                meta: {
                    title: "空调系统",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true
                }
            },
            {
                path: "/fire_control",
                name: "fire_control",
                component: () =>
                    import("./views/pages/fireControl-system/index.vue"),
                meta: {
                    title: "消防系统",
                    // subTitle: "电力能源在线监测管理平台项目",
                    author: false,
                    noMenu: true
                }
            },
            //===================系统配置---start=========================
            {
                path: "/SystemManagement_institutions",
                name: "SystemManagement_institutions",
                component: () =>
                    import(
                        "./views/pages/system/system-institutions-management.vue"
                    ),
                meta: {
                    title: "机构管理",
                    author: true
                }
            },
            //组织机构------------start-----
            {
                path: "/organization",
                name: "organization",
                component: () =>
                    import("./views/pages/system/organization.vue"),
                meta: {
                    title: "用户信息和账号管理",
                    author: true
                }
            },
            //组织机构------------end-----
            {
                path: "/SystemManagement_menu",
                name: "SystemManagement_menu",
                component: () =>
                    import("./views/pages/system/system-menu-management.vue"),
                meta: {
                    title: "菜单管理",
                    author: true
                }
            },
            {
                path: "/SystemManagement_role",
                name: "SystemManagement_role",
                component: () =>
                    import("./views/pages/system/system-role-management.vue"),
                meta: {
                    title: "角色管理",
                    author: true
                }
            },
            {
                path: "/photovoltaic-monitor",
                name: "photovoltaic-monitor",
                component: () =>
                    import("./views/pages/guangfu/photovoltaic-monitor.vue"),
                meta: {
                    title: "光伏监控",
                    author: true
                }
            },
            {
                path: "/bwdjc",
                name: "bwdjc",
                component: () => import("./views/pages/guangfu/bwdjc.vue"),
                meta: {
                    title: "并网点监测",
                    author: true
                }
            },
            {
                path: "/energy-storage",
                name: "energy-storage",
                component: () =>
                    import("./views/pages/guangfu/energy-storage.vue"),
                meta: {
                    title: "储能运行监控",
                    author: true
                }
            },
            {
                path: "/overview-page",
                name: "overview-page",
                component: () =>
                    import("./views/pages/guangfu/overview-page.vue"),
                meta: {
                    title: "充电桩运行监控",
                    author: true
                }
            },
            {
                path: "/nbq_list",
                name: "nbq_list",
                component: () =>
                    import("./views/pages/bwg/nbq_list.vue"),
                meta: {
                    title: "并网柜监测",
                    author: true
                }
            },
            {
                path: "/bwg_manage",
                name: "bwg_manage",
                component: () =>
                    import("./views/pages/bwg/bwg_manage.vue"),
                meta: {
                    title: "并网柜监测",
                    author: true
                }
            },
            {
                path: "/diagram_bwg1",
                name: "diagram_bwg1",
                component: () =>
                    import("./views/pages/svs/diagram/diagram_bwg1.vue"),
                meta: {
                    title: "并网柜接线图",
                    author: true
                }
            },
            {
                path: "/nbq_monitor",
                name: "nbq_monitor",
                component: () =>
                    import("./views/pages/bwg/nbq_monitor.vue"),
                meta: {
                    title: "逆变器状态监测",
                    author: true
                }
            },
            {
                path: "/yskq_monitor",
                name: "yskq_monitor",
                component: () =>
                    import("./views/pages/bwg/yskq_monitor.vue"),
                meta: {
                    title: "压缩空气监测",
                    author: true
                }
            },
            {
                path: "/ww_elec_maintain",
                name: "ww_elec_maintain",
                component: () =>
                    import(
                        "./views/pages/yunxing-control/ww_elec_maintain.vue"
                    ),
                meta: {
                    title: "微网电价维护",
                    author: true
                }
            },
            {
                path: "/absorptiveRate",
                name: "absorptiveRate",
                component: () =>
                    import("./views/pages/guangfu/absorptiveRate.vue"),

                meta: {
                    title: "消纳率分析",
                    author: true
                }
            },
            
            {
                path: "/roof_manage",
                name: "roof_manage",
                component: () =>
                    import("./views/pages/chuneng/roof_manage.vue"),

                meta: {
                    title: "屋顶",
                    author: true
                }
            },
            
            {
                path: "/nbq_power_manage",
                name: "nbq_power_manage",
                component: () =>
                    import("./views/pages/chuneng/nbq_power_manage.vue"),

                meta: {
                    title: "逆变器管理",
                    author: true
                }
            },
            {
                path: "/bwg_power_manage",
                name: "bwg_power_manage",
                component: () =>
                    import("./views/pages/chuneng/bwg_power_manage.vue"),

                meta: {
                    title: "并网柜管理",
                    author: true
                }
            },
            {
                path: "/elec_station_manage",
                name: "elec_station_manage",
                component: () =>
                    import("./views/pages/chuneng/elec_station_manage.vue"),

                meta: {
                    title: "储能一",
                    author: true
                }
            },
            {
                path: "/elec_battery_manage",
                name: "elec_battery_manage",
                component: () =>
                    import("./views/pages/chuneng/elec_battery_manage.vue"),

                meta: {
                    title: "储能二",
                    author: true
                }
            },
            {
                path: "/elec_charge_manage",
                name: "elec_charge_manage",
                component: () =>
                    import("./views/pages/chuneng/elec_charge_manage.vue"),

                meta: {
                    title: "储能三",
                    author: true
                }
            },
            // ================系统配置---end========================
            {
                path: "/Collection-point-design",
                name: "Collection-point-design",
                component: () =>
                    import(
                        "./views/pages/installation-plan/collection-point-design/collection-point-design.vue"
                    ),
                meta: {
                    title: "采集点设计",
                    author: true
                }
            },
            {
                path: "/data_complement",
                name: "data_complement",
                component: () =>
                    import(
                        "./views/pages/installation-plan/data_complement/data_complement.vue"
                    ),
                meta: {
                    title: "数据补录",
                    author: true
                }
            },
            {
                path: "/fhfbpmt",
                name: "fhfbpmt",
                component: () => import("./views/pages/fhfb/fhfbpmt.vue"),
                meta: {
                    title: "负荷分布图",
                    author: true
                }
            },
            {
                path: "/stms_home",
                name: "stms_home",
                component: () => import("./views/pages/stms_home/stms_home.vue"),
                meta: {
                    title: "智慧电力监测平台",
                    author: true
                }
            },
            // 能源管理 start
            {
                path: "/energy-consumption",
                name: "energy-consumption",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/energy-consumption.vue"
                    ),
                meta: {
                    title: "综合电耗分析",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/substation_device_manage",
                name: "substation_device_manage",
                component: () =>
                    import(
                        "./views/pages/svs/substation_device_manage/substation_device_manage.vue"
                    ),
                meta: {
                    title: "变电所设备台账",
                    author: true
                }
            },
            {
                path: "/new_energy_manage",
                name: "new_energy_manage",
                component: () =>
                    import(
                        "./views/pages/svs/new_energy_manage/new_energy_manage.vue"
                    ),
                meta: {
                    title: "新能源运维",
                    author: true
                }
            },
            {
                path: "/run_monitor",
                name: "run_monitor",
                component: () =>
                    import("./views/pages/power-analysis/run_monitor.vue"),
                meta: {
                    title: "微网-新能源发电运行监控",
                    author: false,
                    menuType: 2,
                    isBack: true,
                    backType: "back"
                }
            },
            {
                path: "/tradition_energy_manage",
                name: "tradition_energy_manage",
                component: () =>
                    import(
                        "./views/pages/svs/tradition_energy_manage/tradition_energy_manage.vue"
                    ),
                meta: {
                    title: "传统能源运维",
                    author: true
                }
            },
            {
                path: "/conditioner_monitor",
                name: "conditioner_monitor",
                component: () =>
                    import(
                        "./views/pages/svs/conditioner_monitor/conditioner_monitor.vue"
                    ),
                meta: {
                    title: "冷站监控",
                    author: true
                }
            },
            {
                path: "/dz_air_control",
                name: "dz_air_control",
                component: () =>
                    import(
                        "./views/pages/svs/conditioner_monitor/dz_air_control.vue"
                    ),
                meta: {
                    title: "(东芝)空调监控",
                    author: true
                }
            },
            {
                path: "/rl_air_control",
                name: "rl_air_control",
                component: () =>
                    import(
                        "./views/pages/svs/conditioner_monitor/rl_air_control.vue"
                    ),
                meta: {
                    title: "(日立)空调监控",
                    author: true
                }
            },
            {
                path: "/elec_fee_accounts",
                name: "elec_fee_accounts",
                component: () =>
                    import(
                        "./views/pages/svs/elec_fee_accounts/elec_fee_accounts.vue"
                    ),
                meta: {
                    title: "电费结算",
                    author: true
                }
            }, {
                path: "/pv_settlement",
                name: "pv_settlement",
                component: () =>
                    import(
                        "./views/pages/svs/pv_settlement/pv_settlement.vue"
                        ),
                meta: {
                    title: "光伏电费结算",
                    author: false,
                    menuType: 6
                }
            },{
                path: "/pv_detail",
                name: "pv_detail",
                component: () =>
                    import(
                        "./views/pages/svs/pv_settlement/pv_detail.vue"
                        ),
                meta: {
                    title: "光伏结算详细数",
                    author: false,
                    menuType: 6
                }
            },
            {
                path: "/income_analysis",
                name: "income_analysis",
                component: () =>
                    import(
                        "./views/pages/svs/income_analysis/income_analysis.vue"
                    ),
                meta: {
                    title: "收益分析",
                    author: true
                }
            },
            {
                path: "/carban-check",
                name: "carban-check",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/carban-check.vue"
                    ),
                meta: {
                    title: "碳排放核算",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/carban-out",
                name: "carban-out",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/carban-out.vue"
                    ),
                meta: {
                    title: "碳排放",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/carban-reduce",
                name: "carban-reduce",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/carban-reduce.vue"
                    ),
                meta: {
                    title: "碳排放",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/energy-cost-cons",
                name: "energy-cost-cons",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/energy-cost.vue"
                    ),
                meta: {
                    title: "动能消费桑基图",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/averrage-elec",
                name: "averrage-elec",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/averrage-elec.vue"
                    ),
                meta: {
                    title: "平均电价分析",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/network-dialog",
                name: "network-dialog",
                component: () =>
                    import("./views/pages/yunxing-control/network-dialog.vue"),
                meta: {
                    title: "微网监控",
                    author: true
                }
            },
            {
                path: "/power-report",
                name: "power-report",
                component: () =>
                    import("./views/pages/svs/power_analysis/power_report.vue"),
                meta: {
                    title: "负荷曲线",
                    author: true
                }
            },

            {
                path: "/department_point",
                name: "department_point",
                component: () =>
                    import("./views/pages/energy-page/department_point.vue"),
                meta: {
                    title: "部门采集点",
                    author: true,
                    menuType: 3
                }
            },

            {
                path: "/ele_price",
                name: "ele_price",
                component: () =>
                    import(
                        "./views/pages/svs/power_analysis/ele_price/ele_price.vue"
                    ),
                meta: {
                    title: "电价维护",
                    author: false,
                    menuType: 6
                }
            },
            {
                path: "/check_ele_fee",
                name: "check_ele_fee",
                component: () =>
                    import(
                        "./views/pages/svs/power_analysis/check_ele_fee/check_ele_fee.vue"
                    ),
                meta: {
                    title: "电费结算",
                    author: false,
                    menuType: 6
                }
            },
            {
                path: "/control",
                name: "control",
                component: () => import("./views/pages/control/control.vue"),
                meta: {
                    title: "控制",
                    author: true
                }
            },
            {
                path: "/power_compare",
                name: "power_compare",
                component: () =>
                    import(
                        "./views/pages/power_analysis/power_compare/power_compare.vue"
                    ),
                meta: {
                    title: "功率对比",
                    author: true
                }
            },
            {
                path: "/product_consume",
                name: "product_consume",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/product_consume.vue"
                    ),
                meta: {
                    title: "产品单耗",
                    author: true
                }
            },
            {
                path: "/elec_generate",
                name: "elec_generate",
                component: () =>
                    import("./views/pages/elec_generate/elec_generate.vue"),
                meta: {
                    title: "新能源发电分析",
                    author: true
                }
            },

            {
                path: "/diagram-one",
                name: "diagram-one",
                component: () =>
                    import("./views/pages/svs/diagram/diagram-one.vue"),
                meta: {
                    title: "MO高压",
                    author: false,
                    menuType: 5
                }
            },
            {
                path: "/diagram-two",
                name: "diagram-two",
                component: () =>
                    import("./views/pages/svs/diagram/diagram-two.vue"),
                meta: {
                    title: "MO1#变",
                    author: false,
                    menuType: 5
                }
            },
            {
                path: "/diagram-three",
                name: "diagram-three",
                component: () =>
                    import("./views/pages/svs/diagram/diagram-three.vue"),
                meta: {
                    title: "MO2#变",
                    author: false,
                    menuType: 5
                }
            },
            {
                path: "/diagram-four",
                name: "diagram-four",
                component: () =>
                    import("./views/pages/svs/diagram/diagram-four.vue"),
                meta: {
                    title: "MO3#变",
                    author: false,
                    menuType: 5
                }
            },
            {
                path: "/diagram-five",
                name: "diagram-five",
                component: () =>
                    import("./views/pages/svs/diagram/diagram-five.vue"),
                meta: {
                    title: "MO新",
                    author: false,
                    menuType: 5
                }
            },
            {
                path: "/energy-cost",
                name: "energy-cost",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/energy-cost-chengben.vue"
                    ),
                meta: {
                    title: "能源成本趋势分析",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/power-analysis",
                name: "power-analysis",
                component: () =>
                    import(
                        "./views/pages/energy-storage-sys/power-analysis.vue"
                    ),
                meta: {
                    title: "用电量趋势分析",
                    author: true
                }
            },
            {
                path: "/electricity-cost-analysis",
                name: "electricity-cost-analysis",
                component: () =>
                    import(
                        "./views/pages/energy-storage-sys/electricity-cost-analysis.vue"
                    ),
                meta: {
                    title: "电费趋势分析",
                    author: true
                }
            },
            {
                path: "/energy-check",
                name: "energy-check",
                component: () =>
                    import(
                        "./views/pages/svs/energy-consumption/energy-check.vue"
                    ),
                meta: {
                    title: "万元产值综合电耗考核",
                    author: false,
                    menuType: 3
                }
            },
            {
                path: "/target-management",
                name: "target-management",
                component: () =>
                    import("./views/pages/target-config/target-management.vue"),
                meta: {
                    title: "指标管理",
                    author: false
                }
            },
            {
                path: "/target-config-input",
                name: "target-config-input",
                component: () =>
                    import(
                        "./views/pages/target-config/target-config-input.vue"
                    ),
                meta: {
                    title: "指标数据录入",
                    author: true
                }
            },
            {
                path: "/Field-installation",
                name: "Field-installation",
                component: () =>
                    import(
                        "./views/pages/installation-plan/field-installation/field-installation.vue"
                    ),
                meta: {
                    title: "现场安装",
                    author: true
                }
            },
            {
                path: "/Concentrator-design",
                name: "Concentrator-design",
                component: () =>
                    import(
                        "./views/pages/installation-plan/concentrator-design.vue"
                    ),
                meta: {
                    title: "集中器设计",
                    author: true
                }
            },
            {
                path: "/com-manager-design",
                name: "com-manager-design",
                component: () =>
                    import(
                        "./views/pages/installation-plan/com-manager-design.vue"
                    ),
                meta: {
                    title: "通讯管理机设计",
                    author: true
                }
            },
            {
                path: "/Asset-management",
                name: "Asset-management",
                component: () =>
                    import(
                        "./views/pages/asset-management/equipment-storage.vue"
                    ),
                meta: {
                    title: "设备入库",
                    author: true
                }
            },
            {
                path: "/warn-hour",
                name: "warn-hour",
                component: () =>
                    import(
                        "./views/pages/warn/warn-hour.vue"
                        ),
                meta: {
                    title: "小时报警",
                    author: true
                }
            },
            {
                path: "/warn-instant",
                name: "warn-instant",
                component: () =>
                    import(
                        "./views/pages/warn/warn-instant.vue"
                        ),
                meta: {
                    title: "瞬时持续超限报警",
                    author: true
                }
            },
            {
                path: "/Account-number-maintenance",
                name: "Account-number-maintenance",
                component: () =>
                    import(
                        "./views/pages/system-configuration/account-number-maintenance.vue"
                    ),
                meta: {
                    title: "户号维护",
                    author: true
                }
            },
            {
                path: "/Alarm-configuration",
                name: "Alarm-configuration",
                component: () =>
                    import(
                        "./views/pages/system-configuration/alarm-configuration.vue"
                    ),
                meta: {
                    title: "报警配置",
                    author: true
                }
            },
            {
                path: "/formula-department",
                name: "formula-department",
                component: () =>
                    import(
                        "./views/pages/system-configuration/formula/formula-department.vue"
                    ),
                meta: {
                    title: "功率对比配置",
                    author: true,
                    menuType: 4
                }
            },
            {
                path: "/department_statistics_formula",
                name: "department_statistics_formula",
                component: () =>
                    import(
                        "./views/pages/target-config/department-statistics/department_statistics_formula.vue"
                    ),
                meta: {
                    title: "能耗数据配置",
                    author: true,
                    menuType: 4
                }
            },
            {
                path: "/transformer-manage",
                name: "transformer-manage",
                component: () =>
                    import(
                        "./views/pages/target-config/transformer-manage.vue"
                    ),
                meta: {
                    title: "变压器维护",
                    author: true,
                    menuType: 4
                }
            },
            {
                path: "/category_total",
                name: "category_total",
                component: () =>
                    import("./views/pages/target-config/category_total.vue"),
                meta: {
                    title: "分类字典统计",
                    author: true,
                    menuType: 4
                }
            },
            {
                path: "/category_config",
                name: "category_config",
                component: () =>
                    import("./views/pages/target-config/category_config.vue"),
                meta: {
                    title: "分类统计配置",
                    author: true,
                    menuType: 4
                }
            },
            // 能源管理 end
            // 能耗分析 start
            {
                path: "/TransformerLoad",
                name: "TransformerLoad",
                component: () =>
                    import("./views/pages/power-analysis/transformer-load.vue"),
                meta: {
                    title: "变压器负载分析",
                    author: true
                }
            },
            {
                path: "/pay_unit_month",
                name: "pay_unit_month",
                component: () =>
                    import("./views/pages/power-analysis/pay_unit_month.vue"),
                meta: {
                    title: "外部用电信息",
                    author: true
                }
            },
            {
                path: "/pay_unit_price",
                name: "pay_unit_price",
                component: () =>
                    import("./views/pages/power-analysis/pay_unit_price.vue"),
                meta: {
                    title: "外部用电",
                    author: true
                }
            },
            {
                path: "/pay_unit",
                name: "pay_unit",
                component: () =>
                    import("./views/pages/power-analysis/pay_unit.vue"),
                meta: {
                    title: "外部用户",
                    author: true
                }
            },
            {
                path: "/energy_balance",
                name: "energy_balance",
                component: () =>
                    import("./views/pages/power-analysis/energy_balance.vue"),
                meta: {
                    title: "能源平衡配置",
                    author: true
                }
            },
            {
                path: "/energy_balance_top",
                name: "energy_balance_top",
                component: () =>
                    import(
                        "./views/pages/power-analysis/energy_balance_top.vue"
                    ),
                meta: {
                    title: "能源平衡",
                    author: true
                }
            },
            {
                path: "/capacity-requirement",
                name: "capacity-requirement",
                component: () =>
                    import("./views/pages/jinxian/capacity-requirement.vue"),
                meta: {
                    title: "需量",
                    author: false,
                    menuType: 7
                }
            },
            {
                path: "/directory-power",
                name: "directory-power",
                component: () =>
                    import(
                        "./views/pages/jinxian/incoming-directory-power.vue"
                    ),
                meta: {
                    title: "目录电量",
                    author: false,
                    menuType: 7
                }
            },
            {
                path: "/incomingdirectory-tariff",
                name: "incomingdirectory-tariff",
                component: () =>
                    import(
                        "./views/pages/jinxian/incomingdirectory-tariff.vue"
                    ),
                meta: {
                    title: "目录电费",
                    author: false,
                    menuType: 7
                }
            },
            {
                path: "/incoming-power-factor",
                name: "incoming-power-factor",
                component: () =>
                    import("./views/pages/jinxian/incoming-power-factor.vue"),
                meta: {
                    title: "功率因数",
                    author: false,
                    menuType: 7
                }
            },
            // 能耗分析 end
            // 配电监控 start
            {
                path: "/Use_common_monitor/:point_class_id",
                name: "Use_common_monitor",
                component: () =>
                    import(
                        "./views/pages/Use_common_monitor/Use_common_monitor.vue"
                    ),
                meta: {
                    // title: "用能监测",
                    author: true
                }
            },
            {
                path: "/Use_radiation_monitor",
                name: "Use_radiation_monitor",
                component: () =>
                    import(
                        "./views/pages/Use_radiation_monitor/Use_radiation_monitor.vue"
                        ),
                meta: {
                    // title: "用能监测",
                    author: true
                }
            },
            {
                path: "/Use_electricity_monitor",
                name: "Use_electricity_monitor",
                component: () =>
                    import(
                        "./views/pages/Use_electricity_monitor/Use_electricity_monitor.vue"
                    ),
                meta: {
                    title: "用电监测333",
                    author: true
                }
            },
            {
                path: "/point_control",
                name: "point_control",
                component: () =>
                    import(
                        "./views/pages/system-configuration/point_control.vue"
                    ),
                meta: {
                    title: "控制",
                    author: true
                }
            },
            {
                path: "/Use_electricity_monitor_ly",
                name: "Use_electricity_monitor_ly",
                component: () =>
                    import(
                        "./views/pages/Use_electricity_monitor_ly/Use_electricity_monitor_ly.vue"
                    ),
                meta: {
                    title: "用电监测-鲁阳",
                    author: true
                }
            },
            {
                path: "/Use_water_monitor",
                name: "Use_water_monitor",
                component: () =>
                    import(
                        "./views/pages/Use_water_monitor/Use_water_monitor.vue"
                    ),
                meta: {
                    title: "用水监测",
                    author: true
                }
            },
            {
                path: "/Use_gas_monitor",
                name: "Use_gas_monitor",
                component: () =>
                    import("./views/pages/Use_gas_monitor/use_gas_monitor.vue"),
                meta: {
                    title: "燃气监测",
                    author: true
                }
            },
            {
                path: "/menci_monitor",
                name: "menci_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/menci/menci_monitor.vue"
                    ),
                meta: {
                    title: "门磁",
                    author: true
                }
            },
            {
                path: "/hongwai_monitor",
                name: "hongwai_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/hongwai/hongwai_monitor.vue"
                    ),
                meta: {
                    title: "红外",
                    author: true
                }
            },
            {
                path: "/water_monitor",
                name: "water_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/water/water_monitor.vue"
                    ),
                meta: {
                    title: "水侵",
                    author: true
                }
            },
            {
                path: "/smoke_monitor",
                name: "smoke_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/smoke/smoke_monitor.vue"
                    ),
                meta: {
                    title: "烟感",
                    author: true
                }
            },
            {
                path: "/switch_monitor",
                name: "switch_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/switch/switch_monitor.vue"
                    ),
                meta: {
                    title: "开关",
                    author: true
                }
            },
            {
                path: "/zb_monitor",
                name: "zb_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/zongbao/zb_monitor.vue"
                    ),
                meta: {
                    title: "保护动作",
                    author: true
                }
            },
            {
                path: "/wenshidu_monitor",
                name: "wenshidu_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/wenshidu/wenshidu_monitor.vue"
                    ),
                meta: {
                    title: "温湿度",
                    author: true
                }
            },
            {
                path: "/loudian_monitor",
                name: "loudian_monitor",
                component: () =>
                    import(
                        "./views/pages/realtime-monitor/loudian/loudian_monitor.vue"
                    ),
                meta: {
                    title: "漏电",
                    author: true
                }
            },
            {
                path: "/AlarmStatistics",
                name: "AlarmStatistics",
                component: () =>
                    import("./views/pages/system-warning/alarm-statistics.vue"),
                meta: {
                    title: "报警统计",
                    author: true
                }
            },
            {
                path: "/alarm_event_offline",
                name: "alarm_event_offline",
                component: () =>
                    import(
                        "./views/pages/system-warning/alarm_event_offline.vue"
                    ),
                meta: {
                    title: "离线统计",
                    author: true
                }
            },
            {
                path: "/com_manager_offline",
                name: "com_manager_offline",
                component: () =>
                    import(
                        "./views/pages/system-warning/com_manager_offline.vue"
                    ),
                meta: {
                    title: "实时离线统计",
                    author: true
                }
            },
            {
                path: "/concertor_offline",
                name: "concertor_offline",
                component: () =>
                    import(
                        "./views/pages/system-warning/concertor_offline.vue"
                    ),
                meta: {
                    title: "网关离线统计",
                    author: true
                }
            },
            {
                path: "/alarm_event_overrun",
                name: "alarm_event_overrun",
                component: () =>
                    import(
                        "./views/pages/system-warning/alarm_event_overrun.vue"
                    ),
                meta: {
                    title: "超限报警",
                    author: true
                }
            },
            {
                path: "/alarm_event_switch",
                name: "alarm_event_switch",
                component: () =>
                    import(
                        "./views/pages/system-warning/alarm_event_switch.vue"
                    ),
                meta: {
                    title: "开关报警",
                    author: true
                }
            },
            {
                path: "/alarm_event_protect",
                name: "alarm_event_protect",
                component: () =>
                    import(
                        "./views/pages/system-warning/alarm_event_protect.vue"
                    ),
                meta: {
                    title: "综保报警",
                    author: true
                }
            },
            {
                path: "/alarm_event_unusual",
                name: "alarm_event_unusual",
                component: () =>
                    import(
                        "./views/pages/system-warning/alarm_event_unusual.vue"
                    ),
                meta: {
                    title: "异常数据",
                    author: true
                }
            },
            {
                path: "/CollectionAnomaly",
                name: "CollectionAnomaly",
                component: () =>
                    import(
                        "./views/pages/system-warning/collection-anomaly.vue"
                    ),
                meta: {
                    title: "采集成功率",
                    author: true
                }
            },
            {
                path: "/report_excel",
                name: "report_excel",
                component: () =>
                    import("./views/pages/system-warning/report_excel.vue"),
                meta: {
                    title: "报表下载",
                    author: true
                }
            },
            {
                path: "/report_config",
                name: "report_config",
                component: () =>
                    import("./views/pages/system-warning/report_config.vue"),
                meta: {
                    title: "点位价格",
                    author: true
                }
            },
            // 配电监控 end
            {
                path: "/Power_execl",
                name: "Power_execl",
                component: () =>
                    import("./views/pages/power-analysis/Power_execl.vue"),
                meta: {
                    title: "用电报表",
                    author: true
                }
            },
            {
                path: '/gf_excel',
                name: 'gf_excel',
                component: () =>
                    import('./views/pages/power-analysis/gf_excel.vue'),
                meta: {
                    title: '光伏报表',
                    author: true,
                },
            },
            {
                path: "/data-statistics",
                name: "data-statistics",
                component: () =>
                    import("./views/pages/power-analysis/data_statistics.vue"),
                meta: {
                    title: "数据统计",
                    author: true
                }
            },
            {
                path: "/water_execl",
                name: "water_execl",
                component: () =>
                    import("./views/pages/power-analysis/water_execl.vue"),
                meta: {
                    title: "用水报表",
                    author: true
                }
            },
            {
                path: "/energy_execl/:type",
                name: "energy_execl",
                component: () =>
                    import("./views/pages/power-analysis/energy_execl.vue"),
                meta: {
                    title: "",
                    author: true
                }
            },
            {
                path: "/Power_copy",
                name: "Power_copy",
                component: () =>
                    import("./views/pages/power-analysis/Power_copy.vue"),
                meta: {
                    title: "电能集抄",
                    author: true
                }
            },
            {
                path: "/energy_copy/:type",
                name: "energy_copy",
                component: () =>
                    import("./views/pages/power-analysis/energy_copy.vue"),
                meta: {
                    title: "X能集抄",
                    author: true
                }
            },
            {
                path: "/Year-on-yearAnalysis",
                name: "Year-on-yearAnalysis",
                component: () =>
                    import(
                        "./views/pages/power-analysis/year-on-year-analysis.vue"
                    ),
                meta: {
                    title: "同比分析",
                    author: true
                }
            },
            {
                path: "/Ring-on-ringAnalysis",
                name: "Ring-on-ringAnalysis",
                component: () =>
                    import(
                        "./views/pages/power-analysis/ring-on-ring-analysis.vue"
                    ),
                meta: {
                    title: "环比分析",
                    author: true
                }
            },
            // 智能运维 start
            {
                path: "/equipment_maintain",
                name: "equipment_maintain",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/equipment_maintain/equipment_maintain.vue"
                    ),
                meta: {
                    title: "设备台账维护",
                    author: true
                }
            },
            {
                path: "/Management_group",
                name: "Management_group",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/management_group/management_group.vue"
                    ),
                meta: {
                    title: "班组管理",
                    author: false
                }
            },
            {
                path: "/repair_rush",
                name: "repair_rush",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/repair_rush/repair_rush.vue"
                    ),
                meta: {
                    title: "抢修管理",
                    author: false
                }
            },
            {
                path: "/repair_report",
                name: "repair_report",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/report_repair/report_repair.vue"
                    ),
                meta: {
                    title: "报修管理",
                    author: false
                }
            },
            {
                path: "/defect_manage",
                name: "defect_manage",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/defect_manage/defect_manage.vue"
                    ),
                meta: {
                    title: "缺陷管理",
                    author: false
                }
            },
            {
                path: "/defect_register",
                name: "defect_register",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/defect_manage/defect_register.vue"
                    ),
                meta: {
                    title: "缺陷登记",
                    author: false
                }
            },
            {
                path: "/overhaul_register",
                name: "overhaul_register",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/overhaul_manage/overhaul_register.vue"
                    ),
                meta: {
                    title: "检修计划",
                    author: false
                }
            },
            {
                path: "/overhaul_excute",
                name: "overhaul_excute",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/overhaul_manage/overhaul_excute.vue"
                    ),
                meta: {
                    title: "检修执行",
                    author: false
                }
            },
            {
                path: "/patrol_management",
                name: "patrol_management",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/patrol_management/patrol_management.vue"
                    ),
                meta: {
                    title: "巡检计划",
                    author: false
                }
            },
            {
                path: "/patrol_task",
                name: "patrol_task",
                component: () =>
                    import(
                        "./views/pages/zhinengyunwei/patrol_management/patrol_task.vue"
                    ),
                meta: {
                    title: "巡检任务",
                    author: false
                }
            },
            // 智能运维 end
            {
                path: "/realtime_data",
                name: "realtime_data",
                component: () =>
                    import("./views/pages/svs/realtime_data/realtime_data.vue"),
                meta: {
                    title: "ES-->MYSQL",
                    author: true
                }
            },
            //系统配置 start
            {
                path: "/SystemManagement_refreshRedis",
                name: "SystemManagement_refreshRedis",
                component: () =>
                    import("./views/pages/system/system-refresh-redis.vue"),
                meta: {
                    title: "刷新Redis",
                    author: true
                }
            },
            {
                path: "/userTotal",
                name: "userTotal",
                component: () =>
                    import("./views/pages/asset-management/userTotal.vue"),
                meta: {
                    title: "用户统计",
                    author: true
                }
            },
            {
                path: "/Virtual-point-setting",
                name: "Virtual-point-setting",
                component: () =>
                    import(
                        "./views/pages/system-configuration/virtual-point-setting.vue"
                    ),
                meta: {
                    title: "虚点设置",
                    author: true
                }
            },
            {
                path: "/collect_items",
                name: "collect_items",
                component: () =>
                    import(
                        "./views/pages/system-configuration/collect_items.vue"
                    ),
                meta: {
                    title: "采集项分类",
                    author: true
                }
            },
            {
                path: "/collect_manage",
                name: "collect_manage",
                component: () =>
                    import(
                        "./views/pages/system-configuration/collect_manage.vue"
                    ),
                meta: {
                    title: "采集项管理",
                    author: true
                }
            },
            // {
            //     path: "/sign-out",
            //     name: "sign-out",
            //     component: () => import("./views/pages/sign-on/sign-out.vue"),
            // },
            {
                path: "/404",
                name: "404",
                component: () => import("@/views/exceptions/404"),
                meta: {
                    title: "404",
                    author: true
                }
            },
            {
                path: "/carbon-analysis",
                name: "carbon-analysis",
                component: () => import("@/views/pages/carbon/analysis.vue"),
                meta: {
                    title: "碳分析",
                    author: true
                }
            },
            {
                path: "/room_point",
                name: "carbon-room_point",
                component: () => import("@/views/pages/room/room_point.vue"),
                meta: {
                    title: "能耗分析",
                    author: true
                }
            },
            {
                path: "/MaxTransformerLoad",
                name: "MaxTransformerLoad",
                component: () =>
                    import("./views/pages/power-analysis/max_transformer_load.vue"),
                meta: {
                    title: "变压器最大负载分析",
                    author: true
                }
            },
            {
                path: "/MaxLoadDetail",
                name: "MaxLoadDetail",
                component: () =>
                    import("./views/pages/power-analysis/max_load_detail.vue"),
                meta: {
                    title: "变压器负载详情",
                    author: true
                }
            },
        ]
    },
    {
        path: "/",
        redirect: "login"
    },
    // {
    //     path: "/",
    //     component: Home,
    //     name: "home",
    //     redirect: "home",
    //     children: [
    //         {
    //             path: "/home",
    //             name: "home",
    //             component: () => import("./views/pages/homepage/home.vue"),
    //             meta: {
    //                 author: false,
    //                 keepAlive: true
    //             }
    //         }
    //     ]
    // },

    {
        path: "/login",
        name: "login",
        component: () => import("./views/pages/login/login.vue"),
        meta: {
            title: "login",
            author: false
        }
    },
    {
        path: "/Phone",
        name: "Phone",
        component: () => import("./views/pages/Phone.vue"),
        meta: {
            title: "app下载",
            author: false
        }
    },
    {
        path: "/sign-on",
        name: "sign-on",
        component: () => import("./views/pages/sign-on/sign-on.vue")
    },
    {
        path: "/video-monitor",
        name: "video-monitor",
        component: () => import("./views/pages/video/video-monitor.vue"),
        // component: () =>
        //     import("./views/pages/leader-page/components/video.vue"),
        meta: {
            title: "视频监控",
            author: false,
            noMenu: false
        }
    },

    {
        path: "/blank",
        name: "blank",
        component: () => import("./views/layout/blank.vue"),
        meta: {
            title: "black",
            author: true
        }
    },

    {
        path: "*",
        redirect: "/404"
        // hidden: true
    }
];

export const routerControl = async routes => {
    const assignRoutes = await assignRouter(formatFlatteningRoutes(routes));
};

export function formatFlatteningRoutes(arr) {
    if (arr.length <= 0) return false;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].childlist) {
            arr = arr
                .slice(0, i + 1)
                .concat(arr[i].childlist, arr.slice(i + 1));
        }
    }
    return arr;
}

// 整合路由，将后台返回的meta属性赋值给本地的路由meta权限
const assignRouter = async backRoutes => {
    return (
        staticRoutes &&
        staticRoutes.length &&
        staticRoutes.length >= 1 &&
        staticRoutes[0].children &&
        staticRoutes[0].children.map(item => {
            // /Use_electricity_monitor  /Use_electricity_monitor/005
            // const BackItem = backRoutes.filter(k => k.route_path == item.path);
            const BackItem = backRoutes.filter(
                k => k.route_path.split("/")[1] == item.path.split("/")[1]
            );
            // console.log("fajjkjlk: ", item.path.split("/")[1]);
            if (BackItem.length > 0) {
                item.meta["menuType"] = BackItem[0].sys_code;

                // item.meta["title"] = BackItem[0].menu_name;
                item.childlist && assignRouter(backRoutes);
                return item;
            }
        })
    );
};

const router = new Router({
    mode: "history",
    // base: "/devops/",
    // 跳转路由，重新设置屏幕滚动
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    },
    routes: staticRoutes
});

// 登录验证
router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem("token");
    if (to.meta.author) {
        if (token) {
            next();
        } else {
            if (to.path == "/login") {
                next();
            } else {
                next("./login");
            }
        }
    } else {
        next();
    }
});
export default router;
